import { connect } from "react-redux";
import PaymentDetails from "./paymentDetails";
import { bindActionCreators } from "redux";
import { getVendorPaymentRequestDetail,savePaymentRequest} from "services/redux/sales/vendorPortal/action";


import {
  fetchZones,
} from "services/redux/sales/preSaleListing/action";

const mapStateToProps = (state) => ({
  dataList: state.vendorPortalReducer.payment_request_detail,
  poDetail: state.vendorPortalReducer.poDetail,
 
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchZones,
      savePaymentRequest,
      getVendorPaymentRequestDetail,
      
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PaymentDetails);
